/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountNativeDetailsForQualys extends models.ServiceAccountNativeDetailsBaseForIntegratedTool {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountNativeDetailsForQualys");
    }

    getFixupPrototypeFunction() { return ServiceAccountNativeDetailsForQualys.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountNativeDetailsForQualys>): ServiceAccountNativeDetailsForQualys {
        let obj = Object.assign(new ServiceAccountNativeDetailsForQualys(), model);
        ServiceAccountNativeDetailsForQualys.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountNativeDetailsForQualys>): ServiceAccountNativeDetailsForQualys {
        if (!model) return null;
        return ServiceAccountNativeDetailsForQualys.newInstance(<ServiceAccountNativeDetailsForQualys> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountNativeDetailsForQualys) {
        if (!obj) return;

        models.ServiceAccountNativeDetailsForQualys.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountNativeDetailsForQualys): boolean {
        if (models.ServiceAccountNativeDetailsBaseForIntegratedTool.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountNativeDetailsForQualys.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
